export const WALLET_DETAIL_TAB =
  /^(\/retail-media\/wallet\/[^/]+)\/(movimentations|transactions)$/

const getWalletDetailBasePath = (pathname: string): string | null =>
  WALLET_DETAIL_TAB.exec(pathname)?.[1] ?? null

const isSameWalletDetailTabNavigation = (
  previousPathname: string,
  nextPathname: string
): boolean => {
  const previousBase = getWalletDetailBasePath(previousPathname)
  const nextBase = getWalletDetailBasePath(nextPathname)

  return previousBase !== null && previousBase === nextBase
}

type ScrollPreservationRule = (
  previousPathname: string,
  nextPathname: string
) => boolean

const scrollPreservationRules: ScrollPreservationRule[] = [
  isSameWalletDetailTabNavigation
]

export const shouldPreserveScrollPosition = (
  previousPathname: string | null,
  nextPathname: string
): boolean => {
  if (!previousPathname || previousPathname === nextPathname) {
    return false
  }

  return scrollPreservationRules.some(rule =>
    rule(previousPathname, nextPathname)
  )
}
